export default function SizeTable({
  title,
  data,
  columns,
  columnLabels,
  onRowClick,
  activeRow,
  clickHint,
}) {
  if (!data.length) return null;

  const isActive = (row) => {
    if (!activeRow) return false;
    return (
      row.eu === activeRow.eu &&
      row.international === activeRow.international &&
      row.waistIn === activeRow.waistIn &&
      row.cm === activeRow.cm
    );
  };

  return (
    <div>
      {clickHint && onRowClick && (
        <p className="text-xs text-emerald-500/80 mb-2">{clickHint}</p>
      )}
      <div className="overflow-x-auto rounded-xl border border-slate-700">
        <table className="w-full text-sm text-left">
          <caption className="sr-only">{title}</caption>
          <thead className="bg-slate-800 text-slate-300 uppercase text-xs">
            <tr>
              {columns.map((col) => (
                <th key={col} scope="col" className="px-4 py-3 whitespace-nowrap">
                  {columnLabels[col] || col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => {
              const active = isActive(row);
              return (
                <tr
                  key={i}
                  onClick={() => onRowClick?.(row)}
                  onKeyDown={(e) => e.key === 'Enter' && onRowClick?.(row)}
                  tabIndex={onRowClick ? 0 : undefined}
                  role={onRowClick ? 'button' : undefined}
                  className={`border-t border-slate-700 transition-colors ${
                    onRowClick ? 'cursor-pointer hover:bg-emerald-950/40' : ''
                  } ${active ? 'bg-emerald-900/30 ring-1 ring-inset ring-emerald-500/50' : 'bg-slate-900/50 even:bg-slate-800/30'}`}
                >
                  {columns.map((col) => (
                    <td key={col} className="px-4 py-2 text-slate-200 whitespace-nowrap">
                      {row[col] ?? '—'}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
